import "../../../components/welcomeScreen/welcomeWizard.scss";

import PropTypes from "prop-types";
import React from "react";

import ModalDescription from "../../../components/modal/ModalDescription";
import ModalField from "../../../components/modal/ModalField";
import ModalGroup from "../../../components/modal/ModalGroup";
import ModalRow from "../../../components/modal/ModalRow";
import WelcomeTemplateListView from "../../../components/welcomeScreen/WelcomeTemplateListView";
import templates from "../../../templates";
import preprocessorQuery from "../../../utils/preprocessorQuery";

const isIos = preprocessorQuery.isIos();

/* eslint-disable max-len */

const SelectGroupPage = props => {
  return [
    <ModalGroup key="content">
      <ModalRow>
        <ModalDescription>
          <span>
            Please select the closest template category for your timeline. This will help us suggest updates
            specifically for your timeline, and will not affect your current data.
          </span>
        </ModalDescription>
      </ModalRow>
      {!isIos ? (
        <ModalRow>
          <ModalField />
        </ModalRow>
      ) : null}
      <ModalRow>
        <WelcomeTemplateListView templates={templates} onTemplateClick={props.onGroupClick} />
      </ModalRow>
    </ModalGroup>
  ];
};

SelectGroupPage.propTypes = {
  onGroupClick: PropTypes.func.isRequired
};

export default SelectGroupPage;
